module.exports = __webpack_public_path__ + "static/media/roofSupply.2be32867.png";